import React, { useEffect, useState } from "react";
import { Cart } from "@pearson-ell/commerce-sdk";
import { StyledShoppingCartIcon } from "./ShoppingCartIcon.parts";
import { CartIconSvg } from "../../commons/svgs";

export interface IShoppingCartIconProps {
    cart?: Cart;
    onOpenCart: (cartId: string | undefined) => void;
    timerStartTime?: Date,
    timerDuration?: number;
    timerEllapsedCallback?: () => void;
}

export const ShoppingCartIcon: React.FunctionComponent<
    IShoppingCartIconProps
> = (props: IShoppingCartIconProps) => {
    const [remainingTime, setRemainingTime] = useState("");
    const [ minutes, setMinutes ] = useState(0);
    const count =
        props.cart?.items.reduce((sum, item) => {
            sum += item.quantity;
            return sum;
        }, 0) ?? 0;

    const openCartPage = (e: React.MouseEvent<HTMLDivElement>) => {
        props.onOpenCart("cartpage");
        e.stopPropagation();
    };

    useEffect(() => {
        if (props.timerStartTime) {
            let timeInterval = setTimeout(() => {
                const currentTime = new Date();
                const startTime = typeof (props.timerStartTime) === "string" ? new Date(props.timerStartTime) : props.timerStartTime;
                if (startTime) {
                    const duration = props.timerDuration && props.timerDuration > 0 ? props.timerDuration : 30;
                    const ellapsed = (currentTime.getTime() - startTime.getTime()) / 1000;
                    const target = duration * 60;
                    const remaining = Math.floor(target - ellapsed);
                    if (remaining > 0) {
                        const minutes = Math.floor(remaining / 60);
                        setMinutes(minutes);
                        const seconds = Math.floor(remaining - minutes * 60);
                        setRemainingTime(`${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`);
                    } else if (remaining === 0) {
                        setRemainingTime("");
                        if (props.timerEllapsedCallback) {
                            props.timerEllapsedCallback();
                        }
                    }
                }
            }, 1000);

            return () => {
                clearInterval(timeInterval);
            };
        } else {
            setRemainingTime("");
        }
    });

    return (
        <StyledShoppingCartIcon onClick={openCartPage}>
            <CartIconSvg className="cart-icon" />
            {count > 0 && (
                <span className="total-items">
                    {count > 9 ? "9+" : count}
                </span>
            )}
            {remainingTime && remainingTime !== "" && (
                <div className="timer">
                    <div className="text">Expires in:</div>
                    <div className={"time" + (minutes < 3 ? " warning" : "")}>{remainingTime}</div>
                </div>

            )}
        </StyledShoppingCartIcon>
    );
};
